import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../utils/translations';

const MobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <div className="md:hidden">
      {/* Hamburger Button */}
      <button
        onClick={toggleMenu}
        className="text-white p-2 focus:outline-none"
        aria-label="Menu"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          {isOpen ? (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          ) : (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          )}
        </svg>
      </button>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div className="fixed inset-0 z-50 bg-purple-900 bg-opacity-95">
          <div className="flex flex-col items-center justify-center h-full space-y-8">
            <button
              onClick={closeMenu}
              className="absolute top-6 right-6 text-white text-3xl"
              aria-label="Close Menu"
            >
              ×
            </button>
            
            <Link
              to="/"
              className="text-white text-2xl hover:text-yellow-400 transition"
              onClick={closeMenu}
            >
              {t('home')}
            </Link>
            
            <Link
              to="/about"
              className="text-white text-2xl hover:text-yellow-400 transition"
              onClick={closeMenu}
            >
              {t('aboutUs')}
            </Link>
            
            <Link
              to="/interes"
              className="text-white text-2xl hover:text-yellow-400 transition"
              onClick={closeMenu}
            >
              {language === 'es' ? 'Interés' : language === 'en' ? 'Interest' : 'Interesse'}
            </Link>
            
            <Link
              to="/innovacion-y-hoja-de-ruta"
              className="text-white text-2xl hover:text-yellow-400 transition"
              onClick={closeMenu}
            >
              {language === 'es' ? 'Innovación & Roadmap' : language === 'en' ? 'Innovation & Roadmap' : 'Inovação & Roadmap'}
            </Link>
            
            <Link
              to="/politica-de-privacidad"
              className="text-white text-2xl hover:text-yellow-400 transition"
              onClick={closeMenu}
            >
              {t('privacyPolicy')}
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileMenu;
